module.exports = __webpack_public_path__ + "static/floorplan1-fa8afe6088aabcef28f3db48d06b644b.png";